"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderComponentWebsiteRender = exports.HeaderComponentEditor = exports.HeaderComponentCreator = exports.HeaderComponentRender = void 0;
const react_1 = __importDefault(require("react"));
// import { AiOutlineOrderedList } from 'react-icons/ai'
const react_bootstrap_1 = require("react-bootstrap");
const structure_1 = require("./structure");
function HeaderComponentRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const render = props.render;
    const original = component.original;
    const translated = component.translated;
    const size = component.size;
    const className = props.className;
    // return <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
    //     <div >
    //         {(() => {
    let text = '';
    if (render == 'original') {
        text = react_1.default.createElement("div", { dir: originalDir }, original);
    }
    else if (render == 'translated')
        text = react_1.default.createElement("div", { dir: translatedDir }, translated);
    else
        text = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { dir: originalDir }, original),
            " ",
            react_1.default.createElement("div", { dir: translatedDir }, translated));
    switch (+size) {
        case 1:
            return react_1.default.createElement("h1", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 2:
            return react_1.default.createElement("h2", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 3:
            return react_1.default.createElement("h3", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 4:
            return react_1.default.createElement("h4", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 5:
            return react_1.default.createElement("h5", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        default:
            return react_1.default.createElement("h1", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
    }
    //         })()}
    //     </div>
    // </OverlayTrigger>
}
exports.HeaderComponentRender = HeaderComponentRender;
function HeaderComponentCreator(props) {
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState('');
    const [translated, settranslated] = react_1.default.useState(null);
    const [style, setstyle] = react_1.default.useState({});
    const [size, setsize] = react_1.default.useState(1);
    return react_1.default.createElement("div", { className: 'my-3' },
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", style: { height: '100px' }, onChange: (e) => {
                    setoriginal(e.target.value);
                    dispatch((0, structure_1.headerObject)(e.target.value, translated, size, style));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", style: { height: '100px' }, onChange: (e) => {
                    settranslated(e.target.value);
                    dispatch((0, structure_1.headerObject)(original, e.target.value, size, style));
                } })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u062D\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", type: 'number', min: 1, max: 5, value: size, style: { height: '100px' }, onChange: (e) => {
                    setsize(+e.target.value);
                    dispatch((0, structure_1.headerObject)(original, translated, +e.target.value, style));
                } })));
}
exports.HeaderComponentCreator = HeaderComponentCreator;
function HeaderComponentEditor(props) {
    const component = props.component;
    const dispatch = props.dispatch;
    const [original, setoriginal] = react_1.default.useState(component.original);
    const [translated, settranslated] = react_1.default.useState(component.translated);
    const [size, setsize] = react_1.default.useState(component.size);
    return (react_1.default.createElement("div", { className: 'mx-2 my-3' },
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0627\u0635\u0644\u064A" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", className: 'my-2', onChange: (e) => {
                    setoriginal(e.target.value);
                    dispatch((0, structure_1.headerObject)(e.target.value, translated, size));
                }, value: original !== null && original !== void 0 ? original : '' })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u062A\u0631\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", className: 'my-2', onChange: (e) => {
                    settranslated(e.target.value);
                    dispatch((0, structure_1.headerObject)(original, e.target.value, size));
                }, value: translated !== null && translated !== void 0 ? translated : '' })),
        react_1.default.createElement(react_bootstrap_1.FloatingLabel, { label: "\u062D\u062C\u0645" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "input", type: 'number', min: 1, max: 5, value: size, className: 'my-2', onChange: (e) => {
                    setsize(e.target.value);
                    dispatch((0, structure_1.headerObject)(original, translated, +e.target.value));
                } }))));
}
exports.HeaderComponentEditor = HeaderComponentEditor;
function HeaderComponentWebsiteRender(props) {
    const component = props.component;
    const originalDir = props.originalDir;
    const translatedDir = props.translatedDir;
    const original = component.original;
    const translated = component.translated;
    const size = component.size;
    const render = props.render;
    const className = props.className;
    // console.log('HeaderComponentWebsiteRender size', size == 5)
    let text = '';
    if (render == 'original') {
        text = react_1.default.createElement("div", { dir: originalDir }, original);
    }
    else if (render == 'translated')
        text = react_1.default.createElement("div", { dir: translatedDir }, translated);
    else
        text = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { dir: originalDir }, original),
            " ",
            react_1.default.createElement("div", { dir: translatedDir }, translated));
    switch (+size) {
        case 1:
            return react_1.default.createElement("h1", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 2:
            return react_1.default.createElement("h2", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 3:
            return react_1.default.createElement("h3", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 4:
            return react_1.default.createElement("h4", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        case 5:
            return react_1.default.createElement("h5", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
        default:
            return react_1.default.createElement("h1", { className: className !== null && className !== void 0 ? className : '', id: '1' }, text);
    }
}
exports.HeaderComponentWebsiteRender = HeaderComponentWebsiteRender;
